// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"03ed06a6","239":"73850b33","692":"1651bfcd","732":"a1e6e011","867":"63ee36e6"}[chunkId] + ".chunk.js";
};